<template>
  <v-snackbar
    v-model="$store.state.utils.snackbar"
    absolute
    :location="isMobile ? `top center` : `top right`"
    content-class="custom-snackbar"
    variant="flat"
  >
    <!-- timeout="90000"  for debug-->
    <img
      class="feedback"
      src="@/assets/icons/feedback-success.svg"
      alt="success"
    />
    {{ $store.state.utils.snackbarText }}
  </v-snackbar>
</template>
<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("utils", ["openSnackbar", "closeSnackbar"]),
  },
  computed: {
    isMobile() {
      if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.feedback {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
}
</style>
